__turbopack_context__.v({
  "className": "fragment_mono_cffb7503-module__10mQ9W__className",
  "variable": "fragment_mono_cffb7503-module__10mQ9W__variable",
});
